import type { App } from 'vue'
import AgreementContent from './agreement-content.vue'
import AgreementForm from './agreement-form.vue'
import _MsAside from './ms-aside.vue'
import _MsBreadcrumbHeader from './ms-breadcrumb-header.vue'
import _MsDatePick from './ms-date-pick.vue'
import _MsDragTable from './ms-drag-table.vue'
import _MsEditor from './ms-editor.vue'
import _MsFileOperate from './ms-file-operate.vue'
import _MsFooter from './ms-footer.vue'
import _MsInput from './ms-input.vue'
import _MsPagination from './ms-pagination.vue'
import _MsPopoverInfo from './ms-popover-info.vue'
import _MsRouterView from './ms-router-view.vue'
import _MsSearchForm from './ms-search-form.vue'
import _MsStep from './ms-step.vue'
import _MsSteps from './ms-steps.vue'
import _MsSvgIcon from './ms-svg-icon.vue'
import _MsTable from './ms-table.vue'
import _MsUpload from './ms-upload.vue'

const components = [
  _MsInput,
  _MsSvgIcon,
  _MsSteps,
  _MsStep,
  _MsRouterView,
  _MsUpload,
  _MsBreadcrumbHeader,
  _MsSearchForm,
  _MsDatePick,
  _MsTable,
  _MsPagination,
  _MsFooter,
  _MsDragTable,
  _MsEditor,
  _MsFileOperate,
  _MsPopoverInfo,
  AgreementContent,
  AgreementForm,
].map((it) => {
  it.install = (app: App) => {
    app.component(it.name!, it)
  }
  return it
})

export function install(app: App): void {
  components.forEach(it => it.install(app))
}

export const MsInput = _MsInput
export const MsSvgIcon = _MsSvgIcon
export const MsSteps = _MsSteps
export const MsStep = _MsStep
export const MsAside = _MsAside
export const MsRouterView = _MsRouterView
export const MsUpload = _MsUpload
export const MsBreadcrumbHeader = _MsBreadcrumbHeader
export const MsSearchForm = _MsSearchForm
export const MsDatePick = _MsDatePick
export const MsTable = _MsTable
export const MsPagination = _MsPagination
export const MsFooter = _MsFooter
export const MsDragTable = _MsDragTable
export const MsEditor = _MsEditor
export const MsFileOperate = _MsFileOperate
export const MsPopoverInfo = _MsPopoverInfo
export const MsAgreementContent = AgreementContent
export const MsAgreementForm = AgreementForm
